import { FormStructureTable } from "components/Tables/FormStructureTable/FormStructureTable.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { FormStructureType, PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";
import { getToolStructureHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/")({
    component: LeadStructurePage,
    staticData: {
        permissions: [PermissionEnum.ToolStructureForm],
        showInSideMenu: false,
        label: "pages.tool.structure.lead.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.tool.structure.lead.title"),
        };
    },
});

function LeadStructurePage() {
    return (
        <TenantPage headerNavigationItems={getToolStructureHeaderItems}>
            <FormStructureTable type={FormStructureType.Lead} />
        </TenantPage>
    );
}
